export default () => ({
    activeIndex: 0,

    goTo(index) {
        this.$refs.track.scrollTo({
            left: this.$refs.track.children[index].offsetLeft,
            behavior: 'smooth',
        })
    },

    onScrollEnd() {
        const childWidth = this.$refs.track.offsetWidth
        const videos = [...this.$root.querySelectorAll('video')]

        this.activeIndex = Math.round(this.$refs.track.scrollLeft / childWidth)
        videos.forEach((video) => video.pause())
    },
})
